export const adaptValidator = (validatorFn, modeRef) => (value) => {
  const error = validatorFn(value, modeRef.current);
  return error ?? true;
};

export const adaptValidators = (validatorsMap, modeRef) =>
  Object.fromEntries(
    Object.entries(validatorsMap).map(([key, fn]) => [
      key,
      adaptValidator(fn, modeRef),
    ]),
  );
